import Vue from 'vue';
import Router, { RouteConfig, NavigationGuard } from 'vue-router';
import oauthRely from '../nmb/oauth2/oauth2rely';
import createRoute from '../nmb/oauth2/routes';
import LayOut from '../nmb/components/layout.vue';

const asyncHome = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './home/index.vue');
const asyncNotice = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './notice/index.vue');
const asyncNoticeDetail = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './noticeDetail/index.vue');
const asyncGlobalSearch = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './globalSearch/index.vue');
const asyncExperience = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './experience/index.vue');
const asyncClassReview = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './onlineClass/courseReview.vue');
const asyncOnlineClass = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './onlineClass/index.vue');
const asyncDocument = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './document/index.vue');
const asyncDocDetail = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './document/docDetail.vue');
const asyncDocMarkdown = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './document/docMarkdown.vue');
const asyncTJDocMarkdown = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './document/TJdocMarkdown.vue');
const asyncCallBack = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './document/TJdocMarkdownCallback.vue');

const asyncInsideFeedback = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/feedbackForm/InsideFeedback.vue');
const asyncFeedback = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/index.vue');
const asyncFeedbackList = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/home.vue');
const asyncFeedbackList2 = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/home2.vue');
const asyncFeedbackDetail = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/feedbackDetail/Detail.vue');
const asyncFeedbackTransferDetail = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/feedbackDetail/transferDetail.vue');
const asyncFeedbackEntrance = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/feedbackEntrance.vue');
const asyncSatisfaction = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/feedbackForm/satisfaction.vue');

const asyncFeedBackForm = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './feedback/feedbackForm/FBForm.vue');
const asyncBoard = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './board/index.vue');
const asyncBoardHome = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './board/home.vue');
const asyncAdmin = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './admin/index.vue');
const asyncAdminList = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './admin/home.vue');
const asyncContactsReview = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './contacts/contactView.vue');
const studymap = (): Promise<any> => import(/*webpackChunkName: 'resource' */ './studymap/index.vue');


Vue.use(Router);

const Login: NavigationGuard = (to, from, next) => {

  if (from.name != 'TJdocreview') {
    oauthRely.checkLogon(to, next);
  }

  next();
};

const routes: RouteConfig[] = [
  {
    path: '/documents/TJmdreview',
    name: 'TJdocreview',
    meta: { title: '文档预览', type: '' },
    component: asyncTJDocMarkdown
  },
  {
    path: '/CallBack',
    name: 'CallBack',
    meta: { title: '', type: 'callback' },
    component: asyncCallBack
  },
  {
    path: '/',
    beforeEnter: Login,
    component: LayOut,
    redirect: {
      name: 'home'
    },
    children: [
      {
        path: 'home',
        name: 'home',
        meta: { title: '首页', type: 'home' },
        component: asyncHome
      },
      {
        path: 'home/experience',
        name: 'experience',
        meta: { title: '产品体验中心', type: 'home' },
        component: asyncExperience
      },
      {
        path: 'home/notice/:newsTypeGuid?',
        name: 'notice',
        meta: { title: '公告列表', type: 'home' },
        component: asyncNotice
      },
      {
        path: 'home/noticeDetail/:id',
        name: 'noticeDetail',
        meta: { title: '公告详情', type: 'home' },
        component: asyncNoticeDetail
      },
      {
        path: 'home/contactview',
        name: 'contactView',
        meta: { title: '产品联系人', type: 'home' },
        component: asyncContactsReview
      },
      {
        path: 'documents',
        name: 'documents',
        meta: { title: '文档中心', type: 'documents' },
        component: asyncDocument
      },
      {
        path: 'documents/docreview',
        name: 'docreview',
        meta: { title: '文档预览', type: 'documents' },
        component: asyncDocDetail
      },
      {
        path: 'documents/mdreview',
        name: 'docreview',
        meta: { title: '设计文档预览', type: 'documents' },
        component: asyncDocMarkdown
      },
      {
        path: 'feedback',
        meta: { title: '反馈中心', type: 'feedback' },
        component: asyncFeedback,
        children: [
          { path: '', name: 'feedback', meta: { title: '反馈中心', type: 'feedback' }, component: asyncFeedbackList },
          { path: 'list', name: 'feedback2', meta: { title: '反馈中心', type: 'feedback' }, component: asyncFeedbackList2 },
          { path: 'detail', name: 'detail', meta: { title: '反馈详情', type: 'feedback' }, component: asyncFeedbackDetail },
          { path: 'transferdetail', name: 'transferdetail', meta: { title: '转单详情', type: 'feedback' }, component: asyncFeedbackTransferDetail },
          { path: 'entrance', name: 'entrance', meta: { title: '我要反馈', type: 'feedback' }, component: asyncFeedbackEntrance },
          { path: 'satisfaction', name: 'satisfaction', meta: { title: '满意度评价', type: 'feedback' }, component: asyncSatisfaction },

          { path: 'entrance/:type?', name: 'feedbackform', meta: { title: '我要反馈', type: 'feedback' }, component: asyncFeedBackForm }
        ]
      },
      {
        path: '/feedback/InsideFeedback',
        name: 'InsideFeedback',
        meta: { title: '内部反馈', type: '' },
        component: asyncInsideFeedback
      },
      {
        path: 'board',
        meta: { title: '运营看板', type: 'board' },
        component: asyncBoard,
        children: [
          { path: '', name: 'board', meta: { title: '运营看板', type: 'board' }, component: asyncBoardHome }
        ]
      },
      {
        path: 'course',
        name: 'course',
        meta: { title: '在线课堂', type: 'course' },
        component: asyncOnlineClass
      },
      {
        path: 'course/review',
        name: 'coursereview',
        meta: { title: '在线课堂', type: 'course' },
        component: asyncClassReview
      },
      {
        path: 'home/globalSearch',
        name: 'globalSearch',
        meta: { title: '全局搜索', type: 'home' },
        component: asyncGlobalSearch
      },
      {
        path: 'admin',
        meta: { title: '后台中心', type: 'admin' },
        component: asyncAdmin,
        children: [
          { path: '', name: 'admin', meta: { title: '后台中心', type: 'admin' }, component: asyncAdminList }
        ]
      },
      {
        path: 'studymap',
        meta: { title: '学习地图', type: 'studymap' },
        component: studymap
      }

    ]
  },

  { path: '*', redirect: '/' },
  createRoute()
];

const router: Router = new Router({
  mode: 'history',
  base: '/',
  routes
});

export default router;
